var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inapp-compose"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inAppState.visible),expression:"inAppState.visible"}],staticClass:"inapp-compose-wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('SendMail',{ref:"mailCompose",attrs:{"inAppState":_vm.inAppState}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }